import { useEffect, useState } from 'react';
import {
  addDoc,
  arrayRemove,
  arrayUnion,
  collection,
  deleteDoc,
  deleteField,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

export function useConvites(uid, email) {
  const [convitesRecebidos, setConvitesRecebidos] = useState([]);
  const [convitesEnviados, setConvitesEnviados] = useState([]);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    if (!uid || !email) return;

    let loadR = false;
    let loadE = false;
    const verificar = () => { if (loadR && loadE) setCarregando(false); };

    const unsubR = onSnapshot(
      query(collection(db, 'convites'), where('paraEmail', '==', email.toLowerCase().trim())),
      (snap) => {
        setConvitesRecebidos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        loadR = true;
        verificar();
      }
    );

    const unsubE = onSnapshot(
      query(collection(db, 'convites'), where('deUid', '==', uid)),
      (snap) => {
        setConvitesEnviados(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        loadE = true;
        verificar();
      }
    );

    return () => { unsubR(); unsubE(); };
  }, [uid, email]);

  const enviarConvite = async ({ projetoId, projetoNome, paraEmail, deNome }) => {
    await addDoc(collection(db, 'convites'), {
      projetoId,
      projetoNome,
      deUid: uid,
      deNome,
      paraEmail: paraEmail.toLowerCase().trim(),
      paraUid: null,
      paraNome: null,
      status: 'pendente',
      criadoEm: serverTimestamp(),
      atualizadoEm: serverTimestamp(),
    });
  };

  const aceitarConvite = async (conviteId, convite, usuarioNome, usuarioUid) => {
    await updateDoc(doc(db, 'convites', conviteId), {
      status: 'aceito',
      paraUid: usuarioUid,
      paraNome: usuarioNome,
      atualizadoEm: serverTimestamp(),
    });
    await updateDoc(doc(db, 'projetos', convite.projetoId), {
      membroUids: arrayUnion(usuarioUid),
    });
  };

  const recusarConvite = async (conviteId) => {
    await updateDoc(doc(db, 'convites', conviteId), {
      status: 'recusado',
      atualizadoEm: serverTimestamp(),
    });
  };

  // Remove o membro do projeto e exclui o convite
  const removerMembro = async (conviteId, projetoId, paraUid) => {
    if (!paraUid) return;
    await updateDoc(doc(db, 'projetos', projetoId), {
      membroUids: arrayRemove(paraUid),
      [`membrosPermissoes.${paraUid}`]: deleteField(),
    });
    await deleteDoc(doc(db, 'convites', conviteId));
  };

  // Alterna permissão: 'ativo' ↔ 'somente_leitura'
  const alterarPermissao = async (projetoId, paraUid, permissao) => {
    await updateDoc(doc(db, 'projetos', projetoId), {
      [`membrosPermissoes.${paraUid}`]: permissao,
    });
  };

  const pendentes = convitesRecebidos.filter((c) => c.status === 'pendente');

  return {
    convitesRecebidos,
    convitesEnviados,
    pendentes,
    carregando,
    enviarConvite,
    aceitarConvite,
    recusarConvite,
    removerMembro,
    alterarPermissao,
  };
}
